/* BMA Holzhandel – kleine Interaktionen */
(function () {
  if (!customElements.get('bm-rotator')) {
    class BmRotator extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;
        this.items = Array.from(this.children);
        this.i = 0;
        if (this.items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const ms = parseInt(this.dataset.interval, 10) || 5000;
        this.timer = setInterval(() => this.next(), ms);
        this.addEventListener('mouseenter', () => clearInterval(this.timer));
        this.addEventListener('mouseleave', () => (this.timer = setInterval(() => this.next(), ms)));
      }
      next() {
        this.items[this.i].classList.remove('is-active');
        this.i = (this.i + 1) % this.items.length;
        this.items[this.i].classList.add('is-active');
      }
      disconnectedCallback() {
        clearInterval(this.timer);
      }
    }
    customElements.define('bm-rotator', BmRotator);
  }

  if (!customElements.get('bm-scroller')) {
    class BmScroller extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;
        this.track = this.querySelector('[data-track]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track) return;
        const step = () => Math.max(this.track.clientWidth * 0.85, 240);
        this.prev && this.prev.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
        this.next && this.next.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
        const update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
          if (this.next) this.next.disabled = this.track.scrollLeft >= max;
          this.classList.toggle('is-static', max <= 0);
        };
        this.track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
        setTimeout(update, 600);
      }
    }
    customElements.define('bm-scroller', BmScroller);
  }
})();
